
import { defineComponent } from 'vue'
import { iInputColumn } from '../../FunctionsCatalog'
import Dropdown from 'primevue/dropdown'
import functionsCatalogInputTabDescriptor from './FunctionsCatalogInputTabDescriptor.json'

export default defineComponent({
    name: 'function-catalog-input-column',
    components: { Dropdown },
    props: { column: { type: Object }, readonly: { type: Boolean } },
    emits: ['deleted'],
    data() {
        return {
            functionsCatalogInputTabDescriptor,
            inputColumn: {} as iInputColumn
        }
    },
    watch: {
        column() {
            this.loadColumn()
        }
    },
    created() {
        this.loadColumn()
    },
    methods: {
        loadColumn() {
            this.inputColumn = this.column as iInputColumn
        },
        deleteColumnConfirm() {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.$emit('deleted')
            })
        }
    }
})
